//#region src/utils/replace-file-blob.ts
function e(e, t) {
	let n = `${e.name.replace(/\.[^.]+$/, "")}.png`;
	return new File([t], n, {
		type: "image/png",
		lastModified: e.lastModified
	});
}
//#endregion
export { e as replaceImageFileBlob };
